var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 6.39944V10.8994C13.6 11.6155 13.8845 12.3023 14.3908 12.8086C14.8972 13.315 15.5839 13.5994 16.3 13.5994C17.0161 13.5994 17.7028 13.315 18.2092 12.8086C18.7155 12.3023 19 11.6155 19 10.8994V9.99944C18.9999 7.96816 18.3126 5.99667 17.0499 4.40552C15.7873 2.81437 14.0235 1.69714 12.0454 1.23551C10.0673 0.773874 7.99115 0.994979 6.15462 1.86287C4.31809 2.73076 2.82917 4.1944 1.92994 6.01579C1.03071 7.83718 0.774078 9.9092 1.20176 11.8949C1.62944 13.8807 2.71629 15.6633 4.28557 16.9531C5.85486 18.2428 7.81429 18.9637 9.84527 18.9987C11.8762 19.0336 13.8593 18.3804 15.472 17.1454M13.6 9.99944C13.6 11.9877 11.9882 13.5994 10 13.5994C8.01178 13.5994 6.40001 11.9877 6.40001 9.99944C6.40001 8.01121 8.01178 6.39944 10 6.39944C11.9882 6.39944 13.6 8.01121 13.6 9.99944Z",
    stroke: "#888888",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailInput);
export default __webpack_public_path__ + "static/media/email_input.fcaf9d86d311f6d6808da595d68e3c61.svg";
export { ForwardRef as ReactComponent };